"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCalendar = void 0;
var dateFn = __importStar(require("date-fns"));
var times_1 = __importDefault(require("lodash/times"));
var calendar_date_1 = require("./calendar-date");
var LAST_DAY_OF_WEEK_INDEX = 6;
var DAYS_IN_WEEK = 7;
function isValidYear(year) {
    return year >= 1000 && year <= 9999;
}
/**
 * This beast generates a multi-dimensional array of dates,
 * dayjs date objects to be exact.
 * It takes a date and generates
 */
function createCalendar(options) {
    var month = options.month, year = options.year;
    var today = calendar_date_1.CalendarDate.today();
    var firstDayOfMonth = calendar_date_1.CalendarDate.fromCalendarDate({
        day: 1,
        month: month,
        year: isValidYear(year) ? year : today.getYear(),
    });
    var daysInMonth = dateFn.getDaysInMonth(month);
    var rows = [[]];
    var rowIndex = 0;
    // fill in initial rows
    (0, times_1.default)(daysInMonth, function (num) {
        var nextDay = firstDayOfMonth.addDays(num);
        var dow = nextDay.getDayOfWeek();
        rows[rowIndex].push(nextDay);
        if (dow === LAST_DAY_OF_WEEK_INDEX && num !== daysInMonth - 1) {
            rowIndex += 1;
            rows.push([]);
        }
    });
    var rowLen = rows.length;
    var firstRow = rows[0];
    // backfill days from prev month in first week of month
    if (firstRow.length !== DAYS_IN_WEEK) {
        var backfillBy = DAYS_IN_WEEK - firstRow.length;
        var first = firstRow[0];
        var startOfWeek_1 = first.startOfWeek();
        (0, times_1.default)(backfillBy, function (num) {
            firstRow.splice(num, 0, startOfWeek_1.addDays(num));
        });
    }
    // frontfill days from next month in last week of month
    var lastRow = rows[rowLen - 1];
    if (lastRow.length !== DAYS_IN_WEEK) {
        var fillBy = DAYS_IN_WEEK - lastRow.length;
        var lastLen = lastRow.length;
        var last_1 = lastRow[lastLen - 1];
        (0, times_1.default)(fillBy, function (num) {
            lastRow.push(last_1.addDays(num + 1));
        });
    }
    return rows;
}
exports.createCalendar = createCalendar;
